import dippingSauces from './dippingSauces';
import desserts from './desserts';
import pasta from './pasta';
import sides from './sides';
import drinks from './drinks';
import partyofone from './partyofone';
import {
  NationalMenuTileData,
  WingsNationalMenuData,
  CategoryImages
} from './types';
import wings from './wings';
import categories from './categories';
import melts from './melts';

const nationalMenuData = (category: string): Array<NationalMenuTileData | CategoryImages> | WingsNationalMenuData => {
  switch (category) {
    case 'dips': {
      return dippingSauces;
    }
    case 'desserts': {
      return desserts;
    }
    case 'partyofone': {
      return partyofone;
    }
    case 'pasta': {
      return pasta;
    }
    case 'sides': {
      return sides;
    }
    case 'drinks': {
      return drinks;
    }
    case 'wings': {
      return wings;
    }
    case 'category': {
      return categories;
    }
    case 'melts': {
      return melts;
    }
    default: {
      return [];
    }
  }
};

export default nationalMenuData;
